// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileSyncOutlinedSvg from "@fishx/icons-svg/es/asn/FileSyncOutlined";
import FishxIcon from '../components/FishxIcon';

var FileSyncOutlined = function FileSyncOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileSyncOutlinedSvg
  }));
};

FileSyncOutlined.displayName = 'FileSyncOutlined';
export default React.forwardRef(FileSyncOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileSyncOutlined.js
// module id = 2746
// module chunks = 0